<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onLoaded="onLoaded"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="scanBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Scan Boxes</v-card-title
                >
                <v-select
                    class="mb-0 mx-1"
                    label="Scan Type"
                    ref="scanType"
                    :rules="[rules.required]"
                    :items="scanBoxes.types"
                    v-model="scanBoxes.scanType"
                ></v-select>
                <v-checkbox
                    v-if="scanBoxes.scanType == 'Delivered'"
                    class="my-0"
                    label="Dont Alert"
                    color="success"
                    v-model="scanBoxes.dontAlert"
                ></v-checkbox>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="scanBoxesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveScan"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Boxes</v-card-title
                >
                <v-select
                    class="mb-0 mx-1"
                    label="Routes"
                    ref="boxesRoute"
                    :items="routes"
                    v-model="updateBoxes.route"
                ></v-select>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Truck"
                    ref="boxesTruck"
                    v-model="updateBoxes.truck"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Label Batch"
                    ref="boxesLabelBatch"
                    v-model="updateBoxes.labelBatch"
                ></v-text-field>
                <v-menu
                    v-model="updateBoxes.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="mb-4 mx-1"
                            hide-details
                            v-model="updateBoxes.scheduledDeliveryDate"
                            :value="updateBoxes.scheduledDeliveryDate"
                            label="Delivery Date"
                            prepend-icon="mdi-calendar"
                            ref="boxesDeliveryDate"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="updateBoxes.scheduledDeliveryDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateBoxesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveBoxes"
                    >
                        Save Boxes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="deleteBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Boxes</v-card-title
                >
                <div class="font-weight-regular">
                    {{ selectedRows.length }} boxes will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteBoxesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteBoxes"
                    >
                        Delete Boxes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="updateBoxDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Box</v-card-title
                >
                <div class="mb-3 pa-2" style="border: 2px solid #4caf50">
                    <div>
                        {{ rowClicked.firstName + " " + rowClicked.lastName }}
                    </div>
                    <div>{{ rowClicked.homePhone }}</div>
                </div>

                <v-text-field
                    class="mb-2"
                    label="Address"
                    v-model="rowClicked.address"
                    :rules="[rules.required]"
                    ref="address"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="House"
                    ref="house"
                    :rules="[rules.required]"
                    v-model="rowClicked.house"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Street"
                    ref="street"
                    :rules="[rules.required]"
                    v-model="rowClicked.street"
                ></v-text-field>
                <v-select
                    class="mb-0 mx-1"
                    label="Routes"
                    ref="route"
                    :items="routes"
                    :rules="[rules.required]"
                    v-model="rowClicked.route"
                ></v-select>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Sort"
                    ref="sort"
                    :rules="[rules.required]"
                    v-model="rowClicked.sort"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Truck"
                    ref="truck"
                    :rules="[rules.required]"
                    v-model="rowClicked.truck"
                ></v-text-field>
                <v-text-field
                    class="mb-0 mx-1"
                    label="Label Batch"
                    ref="labelBatch"
                    v-model="rowClicked.labelBatch"
                ></v-text-field>
                <v-menu
                    v-model="rowClicked.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            class="mb-3 mx-1"
                            hide-details
                            v-model="rowClicked.scheduledDeliveryDate"
                            :value="rowClicked.scheduledDeliveryDate"
                            label="Delivery Date"
                            prepend-icon="mdi-calendar"
                            ref="deliveryDate"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="rowClicked.scheduledDeliveryDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="updateBoxDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveBox"
                    >
                        Save Box
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="notificationDialog" max-width="1200">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Broadcast Notification</v-card-title
                >
                <v-layout row class="mb-2">
                    <div class="font-weight-regular mr-3">
                        {{ getSelectedFamilyIDs().length }} families will be
                        notified
                    </div>
                    <div class="mr-3">|</div>
                    <div class="font-weight-regular mr-3">
                        {{ this.selectedRows.length }} rows selected
                    </div>
                </v-layout>
                <v-layout
                    row
                    class="pt-2 px-2"
                    style="border: 2px solid #4caf50; width: 532px;"
                >
                    <v-select
                        label="Setup Name"
                        style="max-width: 250px"
                        v-if="notification.setupNames.length"
                        class="mr-2"
                        :items="notification.setupNames"
                        v-model="notification.setupName"
                        @change="onSelectedSetup"
                        clearable
                    ></v-select>
                    <v-text-field
                        style="max-width: 250px"
                        class="mr-2"
                        label="Setup Name"
                        v-model="notification.setupName"
                        ref="setupName"
                    ></v-text-field>
                    <v-checkbox
                        style="width: 180px;"
                        v-model="notification.shouldMarkAlerted"
                        color="success"
                        label="Mark Alerted"
                    ></v-checkbox>
                </v-layout>
                <v-layout row class="my-3">
                    <v-flex xs7 column>
                        <div class="headline mb-2">Call Setup</div>
                        <v-divider class="pb-2"></v-divider>
                        <div style="height: 300px; overflow-y: auto;">
                            <div
                                v-for="(instruction,
                                index) in notification.callInstructions"
                            >
                                <v-layout row>
                                    <v-select
                                        style="max-width: 120px"
                                        label="Type"
                                        hide-details
                                        class="mr-2"
                                        :items="['Audio', 'Text', 'Data Field']"
                                        v-model="instruction.type"
                                        @change="onTypeChange(instruction)"
                                    ></v-select>

                                    <v-select
                                        label="Data Field"
                                        v-if="instruction.type == 'Data Field'"
                                        class="mr-2"
                                        :items="getBoxFields()"
                                        v-model="instruction.dataField"
                                    ></v-select>

                                    <v-text-field
                                        class="mr-2 width-200"
                                        v-if="instruction.type == 'Audio'"
                                        label="Audio URL"
                                        v-model="instruction.audioURL"
                                        ref="audioURL"
                                    ></v-text-field>
                                    <audio
                                        controls
                                        v-if="instruction.type == 'Audio'"
                                        style="height: 33px"
                                        class="mt-3"
                                        :src="instruction.audioURL"
                                    ></audio>
                                    <audio
                                        controls
                                        v-if="
                                            instruction.type == 'Data Field' &&
                                                instruction.dataField ==
                                                    'LocationFile'
                                        "
                                        style="height: 33px"
                                        class="mt-3"
                                        :src="
                                            selectedRows[0][
                                                lowercaseFirstLetter(
                                                    instruction.dataField,
                                                )
                                            ]
                                        "
                                    ></audio>

                                    <v-textarea
                                        class="pt-0"
                                        v-if="instruction.type == 'Text'"
                                        label="Text"
                                        v-model="instruction.text"
                                        ref="callText"
                                        rows="2"
                                    ></v-textarea>

                                    <v-btn
                                        class="mb-0 mr-3"
                                        v-if="instruction.type == 'Text'"
                                        @click="playText(instruction.text)"
                                        flat
                                        icon
                                        color="info"
                                    >
                                        <v-icon>mdi-play-circle</v-icon>
                                    </v-btn>

                                    <v-btn
                                        class="mb-0"
                                        @click="addInstruction('call', index)"
                                        flat
                                        icon
                                        color="success"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="mb-0"
                                        :disabled="index == 0"
                                        @click="
                                            removeInstruction('call', index)
                                        "
                                        flat
                                        icon
                                        color="#f55a4e"
                                    >
                                        <v-icon
                                            >mdi-minus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </v-layout>
                            </div>
                        </div>
                    </v-flex>
                    <v-divider vertical></v-divider>
                    <v-flex xs5 column>
                        <div class="headline mb-2">SMS Setup</div>
                        <v-divider class="pb-2"></v-divider>
                        <div style="height: 300px; overflow-y: auto;">
                            <div
                                v-for="(instruction,
                                index) in notification.textInstructions"
                            >
                                <v-layout row>
                                    <v-select
                                        style="max-width: 120px"
                                        label="Type"
                                        hide-details
                                        class="mr-2"
                                        :items="['Audio', 'Text', 'Data Field']"
                                        v-model="instruction.type"
                                        @change="onTypeChange(instruction)"
                                    ></v-select>

                                    <v-select
                                        label="Data Field"
                                        v-if="instruction.type == 'Data Field'"
                                        class="mr-2"
                                        :items="getBoxFields()"
                                        v-model="instruction.dataField"
                                    ></v-select>

                                    <v-textarea
                                        class="pt-0"
                                        v-if="instruction.type == 'Text'"
                                        label="Text"
                                        v-model="instruction.text"
                                        ref="callText"
                                        rows="2"
                                    ></v-textarea>

                                    <v-btn
                                        class="mb-0"
                                        @click="addInstruction('sms', index)"
                                        flat
                                        icon
                                        color="success"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="mb-0"
                                        :disabled="index == 0"
                                        @click="removeInstruction('sms', index)"
                                        flat
                                        icon
                                        color="#f55a4e"
                                    >
                                        <v-icon
                                            >mdi-minus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </v-layout>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>

                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="notificationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="sendNotification"
                    >
                        Send Notification
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            color="info"
            top
            right
            :timeout="snackbarTimeout"
            v-model="processingMessagesSnackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    {{ processingMessages }}
                </div>
            </v-layout>
            <v-icon size="16" @click="processingMessagesSnackbar = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
        <v-snackbar
            color="info"
            top
            right
            :timeout="snackbarTimeout"
            v-model="downloadingBatchesSnackbar"
            dark
        >
            <v-layout column>
                <div class="headline mb-2">
                    {{ downloadingBatch }}
                </div>
            </v-layout>
            <v-icon size="16" @click="downloadingBatchesSnackbar = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </div></template
>
<script>
import moment from "moment";
import {
    formatPhoneNumber,
    toISOLocal,
    groupBy,
    toTitleCase,
} from "../../utils/helpers.js";
import AWS from "aws-sdk";
import Pusher from "pusher-js";
import JsZip from "jszip";

export default {
    data: () => ({
        title: "Boxes",

        notificationDialog: false,
        notification: {
            setupNames: [],
            setups: [],
            setupName: "",
            shouldMarkAlerted: false,

            callInstructions: [
                {
                    audioURL: "",
                    dataField: "",
                    text: "",
                    type: "Audio",
                },
            ],
            textInstructions: [
                {
                    dataField: "",
                    text: "",
                    type: "Text",
                },
            ],
        },

        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    switch (value) {
                        case "DELIVERED":
                            return "mdi-check-circle";
                        case "NOT DELIVERED":
                            return "mdi-close-circle";
                        case "SCAN DELETED":
                            return "mdi-delete";
                        case "N/A":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    switch (value) {
                        case "DELIVERED":
                            return "success";
                        case "NOT DELIVERED":
                            return "#f35123";
                        case "SCAN DELETED":
                            return "#aeb8bf";
                        case "N/A":
                            return "#fdb400";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Family ID",
                field: "familyID",
                visible: true,
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "firstName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: true,
                filterValues: [],
                filterValue: null,
                sortOrder: "asc",
                sortIndex: 0,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "fullName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Truck",
                field: "truck",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Boys",
                field: "boys",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Girls",
                field: "girls",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Siblings",
                field: "siblings",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Total Kids",
                field: "totalkids",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Number",
                field: "boxNum",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Of Boxes",
                field: "ofBoxes",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Red",
                field: "red",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Blue",
                field: "blue",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Green",
                field: "green",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Yellow",
                field: "yellow",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Size",
                field: "boxSize",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Sort",
                field: "sort",
                visible: true,
                filterValues: [],
                // sortOrder: "asc",
                // sortIndex: 0,
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Route",
                field: "route",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Label Batch",
                field: "labelBatch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Location File",
                field: "locationFile",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Created",
                field: "dateCreated",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scheduled Delivery Date",
                field: "scheduledDeliveryDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scan Date",
                field: "scanDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alerted Date",
                field: "alertedDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Dont Alert",
                field: "dontAlert",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scanned By",
                field: "user",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "street",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "House",
                field: "house",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street Side",
                field: "streetSide",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cross Street 1",
                field: "crossStreet1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cross Street 2",
                field: "crossStreet2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Apt",
                field: "busApt",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus State",
                field: "busState",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box Note",
                field: "boxNote",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Box ID",
                field: "boxID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,
        routes: [],

        yesterday: moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD HH:mm:ss"),

        selectedRows: [],

        updateBoxesDialog: false,
        scanBoxesDialog: false,
        deleteBoxesDialog: false,
        updateBoxDialog: false,
        snackbarTimeout: 0,
        processingMessagesSnackbar: false,
        downloadingBatchesSnackbar: false,
        downloadingBatch: "",

        rowClicked: "",

        updateBoxes: {
            route: "",
            truck: "",
            labelBatch: "",
            datePickerMenu: false,
            scheduledDeliveryDate: "",
        },

        scanBoxes: {
            scanType: "Delivered",
            types: ["Delivered", "NotDelivered", "Delete"],
            dontAlert: false,
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },

        awsPolly: "",
        requestID: "",
        processingMessages: "",
        totalProcessingMessages: "",
    }),
    async mounted() {
        const settings = await this.getAwsSettings();

        this.awsPolly = new AWS.Polly({
            accessKeyId: settings.accessKey,
            secretAccessKey: settings.secretKey,
            region: "us-east-1",
        });

        this.subscribeToPusher();
    },
    beforeDestroy() {
        this.pusher.unsubscribe("broadcast");
    },
    methods: {
        async getAwsSettings() {
            const response = await this.$http.get(
                "api/adminPortal/GetAwsPollyCredentials",
            );

            return response;
        },
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("broadcast");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("send-sms", (message) => {
                this.updateProcessingNotifications(message);
            });
        },
        updateProcessingNotifications(message) {
            if (message.requestID != this.requestID) return;

            if (message.index == this.totalProcessingMessages) {
                this.processingMessages = "";
                this.processingMessagesSnackbar = false;
            } else {
                this.processingMessages =
                    message.index +
                    "/" +
                    this.totalProcessingMessages +
                    " " +
                    message.text;
            }
        },
        async beforeSetupGrid() {
            this.setupFilter();

            this.url =
                "foodDistributionBoxes?distributionID=" +
                this.$route.query.distributionID;

            await this.loadRoutes();

            this.addActions();
        },
        addActions() {
            this.actions.push({
                text: "Send Notification",
                action: this.openNotificationDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Print Labels",
                isMenu: true,
                items: [
                    {
                        value: "selected",
                        text: "Print",
                    },
                    {
                        value: "batches",
                        text: "Print Batches",
                    },
                ],
                value: "PrintLabel",
                name: "PrintLabel",
                action: this.printLabels,
            });

            this.actions.push({
                text: "Boxes",
                isMenu: true,
                items: [
                    {
                        value: "scan",
                        text: "Scan",
                    },
                    {
                        value: "update",
                        text: "Update",
                    },
                    {
                        value: "delete",
                        text: "Delete",
                    },
                ],
                value: "ChangeBoxes",
                action: this.changeBoxes,
                showOnSelection: true,
            });
        },
        changeBoxes(option) {
            if (option == "delete") return this.openDeleteBoxesDialog();
            if (option == "scan") return this.openScanBoxesDialog();

            return this.openUpdateBoxesDialog();
        },
        async loadRoutes() {
            const routes = await this.$http.get(
                "api/foodDistributionRoutes/getRouteNames",
            );

            this.routes = routes.filter(Boolean);
        },
        onLoaded(data) {
            if (!data.length) return;

            data.forEach(
                (d) => (d.sort = d.sort ? d.sort.replace(/^0+/, "") : ""),
            );
        },
        onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.rowClicked.datePickerMenu = false;
            this.rowClicked.scheduledDeliveryDate = toISOLocal(
                new Date(this.rowClicked.scheduledDeliveryDate),
            ).substr(0, 10);

            this.updateBoxDialog = true;
        },
        setupFilter() {
            this.setupRouteFilter();
            this.resetStatusFilter();

            const filter = this.$route.query.filter;

            if (!filter) return;

            const column = this.columns.find(
                (c) => c.field == "status" && !c.isIcon,
            );

            if (filter == "unScannedBoxes") {
                column.filterValue = "N/A";
                column.selectedFilterOperation = "=";
            } else if (filter == "scannedBoxes" || filter == "delivered") {
                column.filterValue = "DELIVERED";
                column.selectedFilterOperation = "=";
            } else if (filter == "unDelivered") {
                column.filterValue = "DELIVERED";
                column.selectedFilterOperation = "<>";
            }
        },
        setupRouteFilter() {
            this.resetRouteFilter();

            const route = this.$route.query.route;

            if (!route) return;

            const routeColumn = this.columns.find((c) => c.field == "route");

            routeColumn.filterValue = route;
            routeColumn.selectedFilterOperation = "=";

            const scheduledDeliveryDate = this.$route.query
                .scheduledDeliveryDate;

            if (!scheduledDeliveryDate) return;

            const scheduledDeliveryDateColumn = this.columns.find(
                (c) => c.field == "scheduledDeliveryDate",
            );

            scheduledDeliveryDateColumn.filterValue = scheduledDeliveryDate;
            scheduledDeliveryDateColumn.selectedFilterOperation = "=";
        },
        resetStatusFilter() {
            let state = localStorage.getItem("foodDistributionBoxes");

            if (state) {
                state = JSON.parse(state);

                const statusColumns = state.columns.filter(
                    (c) => c.dataField == "status",
                );

                statusColumns.forEach((column) => {
                    column.filterValue = "";
                    column.selectedFilterOperation = null;
                });

                localStorage.setItem(
                    "foodDistributionBoxes",
                    JSON.stringify(state),
                );
            }
        },
        resetRouteFilter() {
            let state = localStorage.getItem("foodDistributionBoxes");

            if (state) {
                state = JSON.parse(state);

                const columns = state.columns.filter(
                    (c) =>
                        c.dataField == "route" ||
                        c.dataField == "scheduledDeliveryDate",
                );

                columns.forEach((column) => {
                    column.filterValue = "";
                    column.selectedFilterOperation = null;
                });

                localStorage.setItem(
                    "foodDistributionBoxes",
                    JSON.stringify(state),
                );
            }
        },
        openUpdateBoxesDialog() {
            this.updateBoxesDialog = true;
            const selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );

            this.selectedRows = selectedRows.map((row) => {
                row.scheduledDeliveryDate = toISOLocal(
                    new Date(row.scheduledDeliveryDate),
                ).substr(0, 10);
                return row;
            });
        },
        openDeleteBoxesDialog() {
            this.deleteBoxesDialog = true;
            this.selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );
        },
        openScanBoxesDialog() {
            this.scanBoxesDialog = true;
            this.selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );
        },
        lowercaseFirstLetter(string) {
            return string.charAt(0).toLowerCase() + string.slice(1);
        },
        async saveBox() {
            if (
                !this.$refs.address.validate(true) ||
                !this.$refs.route.validate(true) ||
                !this.$refs.sort.validate(true) ||
                !this.$refs.truck.validate(true) ||
                !this.$refs.deliveryDate.validate(true) ||
                !this.$refs.house.validate(true) ||
                !this.$refs.street.validate(true)
            )
                return;

            try {
                this.processing = true;

                await this.$http.post("api/foodDistributionBoxes/updateBox", {
                    boxID: this.rowClicked.boxID,
                    address: this.rowClicked.address,
                    route: this.rowClicked.route,
                    sort: this.rowClicked.sort,
                    labelBatch: this.rowClicked.labelBatch,
                    street: this.rowClicked.street,
                    house: this.rowClicked.house,
                    truck: this.rowClicked.truck,
                    scheduledDeliveryDate: this.rowClicked
                        .scheduledDeliveryDate,
                });

                this.processing = false;
                this.updateBoxDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Box Updated",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveScan() {
            if (!this.$refs.scanType.validate(true)) return;

            try {
                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                await this.$http.post("api/foodDistributionScans/scanBoxes", {
                    boxIDs: ids,
                    user: this.$store.state.authentication.user,
                    scanType: this.scanBoxes.scanType,
                    dontAlert:
                        this.scanBoxes.scanType == "Delivered"
                            ? this.scanBoxes.dontAlert
                            : false,
                });

                this.processing = false;
                this.scanBoxesDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Boxes Scanned",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteBoxes() {
            try {
                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                await this.$http.post("api/foodDistributionBoxes/deleteBoxes", {
                    boxIDs: ids,
                    //user: this.user
                });

                this.processing = false;
                this.deleteBoxesDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Boxes Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async openNotificationDialog() {
            const setups = await this.$http.get(
                "api/foodDistributionAccountInfo/getNotificationSetups",
            );

            setups.forEach((s) => {
                s.broadcastType = s.type == "TEXT" ? "TEXT" : "CALL";

                if (s.audioURL) {
                    s.type = "Audio";
                } else if (s.text) {
                    s.type = "Text";
                } else if (s.dataField) {
                    s.type = "Data Field";
                }
            });

            const group = groupBy(setups, "name");
            this.notification.setupNames = [];

            Object.keys(group).forEach((key) => {
                this.notification.setupNames.push(key);
            });

            if (this.notification.setupNames.length) {
                this.notification.setupName = this.notification.setupNames[0];

                if (
                    this.getCallSetup(setups, this.notification.setupName)
                        .length
                ) {
                    this.notification.callInstructions = this.getCallSetup(
                        setups,
                        this.notification.setupName,
                    );
                }

                if (
                    this.getTextSetup(setups, this.notification.setupName)
                        .length
                ) {
                    this.notification.textInstructions = this.getTextSetup(
                        setups,
                        this.notification.setupName,
                    );
                }
            }

            this.notification.setups = setups;

            this.notificationDialog = true;

            this.selectedRows = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );
        },
        getCallSetup(setups, setupName) {
            return setups
                .filter((s) => s.name == setupName && s.broadcastType == "CALL")
                .sort((a, b) => a.id - b.id);
        },
        getTextSetup(setups, setupName) {
            return setups
                .filter((s) => s.name == setupName && s.broadcastType == "TEXT")
                .sort((a, b) => a.id - b.id);
        },
        onTypeChange(instruction) {
            instruction.dataField = "";
            instruction.audioURL = "";
            instruction.text = "";
        },
        async saveBoxes() {
            try {
                if (
                    //!this.$refs.boxesRoute.validate(true) ||
                    //!this.$refs.boxesTruck.validate(true) ||
                    !this.$refs.boxesDeliveryDate.validate(true)
                )
                    return;

                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                await this.$http.post("api/foodDistributionBoxes/updateBoxes", {
                    boxIDs: ids,
                    route: this.updateBoxes.route,
                    truck: this.updateBoxes.truck,
                    labelBatch: this.updateBoxes.labelBatch,
                    scheduledDeliveryDate: this.updateBoxes
                        .scheduledDeliveryDate,
                });

                this.processing = false;
                this.updateBoxesDialog = false;

                this.$notify({
                    group: "notification",
                    text: "Boxes Updated",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async printLabels(option) {
            if (option == "selected") return await this.printSelectedLabels();

            return await this.printLabelBatches();
        },
        async printSelectedLabels() {
            var grid = this.$refs.grid;

            const sortOptions = grid.dataSource.loadOptions().sort.length
                ? grid.dataSource.loadOptions().sort[0]
                : "";

            const selected = grid.getSelectedRowsData();

            if (!selected.length) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Boxes",
                    type: "error",
                });

                return;
            }

            const sort = sortOptions
                ? sortOptions.selector +
                  " " +
                  (sortOptions.desc ? "desc" : "asc")
                : "";

            const ids = selected.map((d) => d.boxID);

            try {
                const response = await this.$http({
                    url: "api/foodDistributionBoxes/printLables",
                    method: "POST",
                    data: { selectedIDs: ids, orderBy: sort },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "BoxesLabels.pdf");
                document.body.appendChild(link);
                link.click();
            } catch (e) {}
        },
        async printLabelBatches() {
            const data = await this.$refs.grid.getSelectedRowsData();

            if (!data.length) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Boxes",
                    type: "error",
                });

                return;
            }

            const groupByLabelBatch = groupBy(data, "labelBatch");

            const zip = new JsZip();

            const total = Object.keys(groupByLabelBatch).length * 2;

            let i = 0;
            for (const key of Object.keys(groupByLabelBatch)) {
                const batch = groupByLabelBatch[key];

                const groupByStreetSide = groupBy(batch, "streetSide");

                for (const groupByStreetSideKey of Object.keys(
                    groupByStreetSide,
                )) {
                    i++;

                    const boxes = groupByStreetSide[groupByStreetSideKey];

                    const ids = boxes.map((d) => d.boxID);

                    try {
                        const response = await this.$http({
                            url: "api/foodDistributionBoxes/printLables",
                            method: "POST",
                            data: { selectedIDs: ids, orderBy: "" },
                            responseType: "blob",
                        });

                        this.downloadingBatchesSnackbar = true;

                        const fileName =
                            key + "_" + groupByStreetSideKey + ".pdf";
                        zip.file(fileName, new Blob([response]));

                        //const current = index + 1;

                        this.downloadingBatch =
                            i +
                            "/" +
                            total +
                            " " +
                            key +
                            " - " +
                            groupByStreetSideKey;
                    } catch (e) {}
                }
            }

            this.downloadingBatchesSnackbar = false;
            this.downloadingBatch = "";

            zip.generateAsync({ type: "blob" }).then(function(content) {
                const url = window.URL.createObjectURL(new Blob([content]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Label Batches.zip");
                document.body.appendChild(link);
                link.click();
            });
        },
        onSelectedSetup(value) {
            if (!value) return;

            const setups = this.notification.setups.filter(
                (s) => s.name == value,
            );

            if (this.getCallSetup(setups, value).length) {
                this.notification.callInstructions = this.getCallSetup(
                    setups,
                    value,
                );
            } else {
                this.notification.callInstructions = [
                    {
                        audioURL: "",
                        dataField: "",
                        text: "",
                        type: "Audio",
                    },
                ];
            }

            if (this.getTextSetup(setups, value).length) {
                this.notification.textInstructions = this.getTextSetup(
                    setups,
                    value,
                );
            } else {
                this.notification.textInstructions = [
                    {
                        dataField: "",
                        text: "",
                        type: "Text",
                    },
                ];
            }
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Joanna",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
        addInstruction(type, index) {
            if (type == "call") {
                this.notification.callInstructions.splice(index + 1, 0, {
                    audioURL: "",
                    dataField: "",
                    text: "",
                    type: "Audio",
                });
            } else {
                this.notification.textInstructions.splice(index + 1, 0, {
                    dataField: "",
                    text: "",
                    type: "Text",
                });
            }

            this.$forceUpdate();
        },
        removeInstruction(type, index) {
            if (type == "call") {
                this.notification.callInstructions.splice(index, 1);
            } else {
                this.notification.textInstructions.splice(index, 1);
            }

            this.$forceUpdate();
        },
        getBoxFields() {
            const box = this.selectedRows[0];

            return Object.keys(box)
                .map((b) => toTitleCase(b))
                .sort();
        },
        getSelectedFamilyIDs() {
            if (!this.selectedRows) return [];

            const group = groupBy(this.selectedRows, "familyID");

            const familyIDs = [];

            Object.keys(group).forEach((key) => {
                familyIDs.push(key);
            });

            return familyIDs;
        },
        async sendNotification() {
            try {
                // if (
                //     !this.$refs.boxesRoute.validate(true)
                // )
                //     return;

                const ids = this.selectedRows.map((s) => s.boxID);

                this.processing = true;

                this.requestID = Math.floor(Math.random() * 10000000);

                this.totalProcessingMessages = this.getSelectedFamilyIDs().length;
                this.processingMessages = "0/" + this.totalProcessingMessages;

                const distributionID = this.selectedRows[0].distributionID;

                this.$http.post("api/foodDistributionAccountInfo/Broadcast", {
                    requestID: this.requestID,
                    user: this.$store.state.authentication.user,
                    distributionID: distributionID,
                    familyIDs: this.getSelectedFamilyIDs(),
                    setupName: this.notification.setupName,
                    callInstructions: this.notification.callInstructions,
                    textInstructions: this.notification.textInstructions,
                    shouldMarkAlerted: this.notification.shouldMarkAlerted,
                });

                this.processing = false;
                this.notificationDialog = false;
                this.processingMessagesSnackbar = true;

                this.$notify({
                    group: "notification",
                    text: "Notification Are Being Sent",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
